<template>
  <div class="main" ref="main">
    <template v-if="abnormalData && abnormalData.length">
      <h1>异常指标预警详情</h1>
      <el-button
        style="float: right; margin-top: -30px"
        @click="$router.go(-1)"
        size="mini"
        >返回</el-button
      >
      <div class="riskStatistical">
        <div
          class=""
          ref="zhexianturef"
          style="height: 500px; width: 100%"
        ></div>
      </div>
      <h1>疾病指向预警</h1>
      <div class="riskStatistical">
        <div
          class=""
          ref="sandianturef"
          style="height: 500px; width: 100%"
        ></div>
      </div>
      <el-row style="margin-top: 50px" :gutter="20">
        <el-col :span="12">
          <el-row>
            <el-col :span="12"><h4>血压变化趋势</h4></el-col>
            <el-col :span="12" class="right-btns">
              <el-radio-group
                v-model="xueyaV"
                @input="getxueya"
                size="mini"
                class="h_select_history"
              >
                <el-radio-button label="all">全部</el-radio-button>
                <el-radio-button label="month">月历史</el-radio-button>
                <el-radio-button label="year">年历史</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
          <div class="riskStatistical">
            <div class="tubiaosize" ref="xueya"></div>
          </div>
        </el-col>
        <el-col :span="12">
          <el-row>
            <el-col :span="12"><h4>空腹血糖变化趋势</h4></el-col>
            <el-col :span="12" class="right-btns">
              <el-radio-group
                v-model="xuetangV"
                @input="getxuetang"
                size="mini"
                class="h_select_history"
              >
                <el-radio-button label="all">全部</el-radio-button>
                <el-radio-button label="month">月历史</el-radio-button>
                <el-radio-button label="year">年历史</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
          <div class="riskStatistical">
            <div class="tubiaosize" ref="xuetang"></div>
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-top: 50px" :gutter="20">
        <el-col :span="12">
          <el-row>
            <el-col :span="12"><h4>血脂(总胆固醇)变化趋势</h4></el-col>
            <el-col :span="12" class="right-btns">
              <el-radio-group
                v-model="xuezhiV"
                @input="getxuezhi"
                size="mini"
                class="h_select_history"
              >
                <el-radio-button label="all">全部</el-radio-button>
                <el-radio-button label="month">月历史</el-radio-button>
                <el-radio-button label="year">年历史</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
          <div class="riskStatistical">
            <div class="tubiaosize" ref="xuezhi"></div>
          </div>
        </el-col>
        <el-col :span="12">
          <el-row>
            <el-col :span="12"><h4>尿酸变化趋势</h4></el-col>
            <el-col :span="12" class="right-btns">
              <el-radio-group
                v-model="niaosuanV"
                @input="getniaosuan"
                size="mini"
                class="h_select_history"
              >
                <el-radio-button label="all">全部</el-radio-button>
                <el-radio-button label="month">月历史</el-radio-button>
                <el-radio-button label="year">年历史</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
          <div class="riskStatistical">
            <div class="tubiaosize" ref="niaosuan"></div>
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-top: 50px" :gutter="20">
        <el-col :span="12">
          <el-row>
            <el-col :span="12"><h4>体重变化趋势</h4></el-col>
            <el-col :span="12" class="right-btns">
              <el-radio-group
                v-model="tizhongV"
                @input="gettizhong"
                size="mini"
                class="h_select_history"
              >
                <el-radio-button label="all">全部</el-radio-button>
                <el-radio-button label="month">月历史</el-radio-button>
                <el-radio-button label="year">年历史</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
          <div class="riskStatistical">
            <div class="tubiaosize" ref="tizhong"></div>
          </div>
        </el-col>
        <el-col :span="12">
          <el-row>
            <el-col :span="12"><h4>BMI变化趋势</h4></el-col>
            <el-col :span="12" class="right-btns">
              <el-radio-group
                v-model="bmiV"
                @input="getbmi"
                size="mini"
                class="h_select_history"
              >
                <el-radio-button label="all">全部</el-radio-button>
                <el-radio-button label="month">月历史</el-radio-button>
                <el-radio-button label="year">年历史</el-radio-button>
              </el-radio-group>
            </el-col>
          </el-row>
          <div class="riskStatistical">
            <div class="tubiaosize" ref="bmi"></div>
          </div>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24" class="search-box">
          <!-- <div>
            <span>来源筛选</span>
          <el-select
            style="margin-left: 10px;"
            v-model="searchParams.appId"
            placeholder="请选择"
          >
            <el-option
              v-for="item in appIdList"
              :key="item.appId"
              :label="item.clientName == '全部'?item.clientName:(item.appId?item.appId + '  ' + item.clientName:item.clientName)"
              :value="item.appId"
            >
            </el-option>
          </el-select>
        </div>
          <el-select
            style="margin-left: 10px;"
            v-model="searchParams.sourcePort"
            placeholder="请选择"
          >
            <el-option
              v-for="item in sourcePortList"
              :key="item"
              :label="item?item :'全部来源端'"
              :value="item"
            >
            </el-option>
          </el-select>
          <el-select
            style="margin-left: 10px;"
            v-model="searchParams.sourceEntrance"
            placeholder="请选择"
          >
            <el-option
              v-for="item in sourceEntranceList"
              :key="item"
              :label="item ? item:'全部来源入口' "
              :value="item"
            >
            </el-option>
          </el-select>
          <el-select
            style="margin-left: 10px;"
            v-model="searchParams.sourceCategory"
            placeholder="请选择"
          >
            <el-option
              v-for="item in sourceCategoryList"
              :key="item"
              :label="item ? item : '全部来源类别'"
              :value="item"
            >
            </el-option>
          </el-select>
          -->
        </el-col>
        <el-col :span="24" style="margin-top: 20px">
          <span>指标名称</span>
          <!-- <el-input
            style="margin-left: 20px; width: 450px"
            placeholder="请输入指标名称等关键字查询"
            v-model="searchParams.title"
            clearable
          > 
        </el-input>-->
          <el-select
            v-model="searchParams.title"
            filterable
            style="margin-left: 20px; width: 450px"
          >
            <el-option
              v-for="item in allList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button
            @click="handerReset"
            class="resetButton"
            type="primary"
            plain
            >重置</el-button
          >
          <el-button @click="handerQuery" class="resetButton" type="primary"
            >查询</el-button
          >
        </el-col>
      </el-row>
      <div class="table">
        <el-table :data="anomalyIndexData" border style="width: 100%">
          <el-table-column
            prop="dateTimeString"
            label="生成时间"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="baseItemName"
            label="指标名称"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="referenceValue"
            label="正常参考值"
            align="center"
            show-overflow-tooltip
            :render-header="renderHeaderMethod"
          ></el-table-column>
          <el-table-column
            prop="baseItemValue"
            label="结果值"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <!-- 数据来源 -->
          <el-table-column
            prop="source"
            label="数据来源"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="abnormalTips"
            label="异常提示"
            align="center"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="abnormalIndicatorLevelName"
            label="异常等级"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="disease-mark">{{
                scope.row.abnormalIndicatorLevelName
              }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="diseasePointName"
            label="疾病指向"
            align="center"
            show-overflow-tooltip
            :render-header="renderHeaderMethod2"
          >
            <template slot-scope="scope">
              <span class="disease-mark">{{ scope.row.diseasePointName }}</span>
            </template></el-table-column
          >

          <!-- 预警等级 -->
          <el-table-column
            prop="level"
            label="预警等级"
            align="center"
            show-overflow-tooltip
          >
            <!-- <template slot-scope="scope">
              <span class="level-mark">{{
                scope.row.level == 1 ? "低" : scope.row.level == 2 ? "中" : "高"
              }}</span>
            </template> -->
          </el-table-column>
          <!-- <el-table-column
            prop="effective"
            label="有效性"
            align="center"
            width="100"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                class="effective-icon"
                :class="{ 'effective-icon-highlight': scope.row.hasOverdue }"
              ></span>
              <span class="effective-text">{{
                scope.row.hasOverdue ? "失效" : "有效"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="appId"
            label="AppID"
            align="center"
            width="100"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="channelName"
            label="渠道名称"
            align="center"
            width="110"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="sourcePort"
            label="来源端"
            align="center"
            width="110"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="sourceEntrance"
            label="来源入口"
            align="center"
            width="110"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="sourceCategory"
            label="来源类别"
            align="center"
            width="110"
            show-overflow-tooltip
          ></el-table-column> -->
          <el-table-column align="center" label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="handleDecode(scope.row)"
                >解读</el-button
              >
              <!-- <el-button
                type="text"
                @click="handleCheck(scope.$index, scope.row.reportId)"
                >查看体检报告</el-button
              > -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="block104">
        <el-pagination
          background
          :current-page="current"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          :total="totalCount"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
      <el-dialog title="异常解读" :visible.sync="dialogTableVisible">
        <el-table
          :data="gridData"
          :show-header="false"
          border
          style="width: 100%"
        >
          <!-- <el-table-column
            prop="description"
            label="description"
          ></el-table-column> -->
          <el-table-column
            prop="name"
            label="日期"
            min-width="20%"
            align="left"
          ></el-table-column>
          <el-table-column
            prop="description"
            label="姓名"
            min-width="80%"
            align="left"
          ></el-table-column>
        </el-table>
      </el-dialog>
    </template>
    <template v-else>
      <div class="healthNonData">
        <img
          src="@/assets/images/hcalc2.png"
          class="healthNonDataImage"
          alt=""
        />
        <div class="healthNonDataText">暂无异常指标</div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  getBubbleData,
  getClientList,
  getAbnormalWarning,
  getRecordsList,
  getHealthUserAbnormalIndicatorList,
  getHAbnormalIndicator,
  getHealthAbnormalIndicator,
  getAnomalData,
} from "@/config/healthApi.js";
import { isEmpty, getYMDString, getYMDSimple } from "@/assets/js/until.js";
const defaultSearchObj = {
  appId: "",
  sourcePort: "",
  sourceEntrance: "",
  sourceCategory: "",
  title: "",
};
export default {
  components: {},
  name: "health-anomalyIndex",
  data() {
    return {
      allList: [],
      pageloading: true,
      xueyaV: "all",
      xuetangV: "all",
      xuezhiV: "all",
      niaosuanV: "all",
      tizhongV: "all",
      bmiV: "all",
      appIdList: [
        {
          appId: null,
          clientName: "全部",
        },
      ],
      options1: [
        {
          value: 2,
          label: "全部",
        },
        {
          value: 1,
          label: "有",
        },
        {
          value: 0,
          label: "无",
        },
      ],
      // 当前结果条数
      totalCount: 0,
      // 当前激活页码
      current: 1,
      //可选的每页条数
      pageSizes: [10, 20, 30, 40],
      // 每页显示多少条
      pageSize: 10,
      tableLabel: [],
      anomalyIndexData: [],
      navTitle: "异常指标",
      gridData: [],
      dialogTableVisible: false,
      abnormalData: [],
      searchParams: JSON.parse(JSON.stringify(defaultSearchObj)),
      sourcePortList: [],
      sourceEntranceList: [],
      sourceCategoryList: [],
      scatterColorList: ["#16D18D", "#9ED500", "#DB7957", "#A0523D"],
      levalList: ["轻度预警", "中度预警", "高度预警"],
    };
  },
  created() {},
  mounted() {
    if (this.$store.state.healthDocUser.isSuperManager) {
      if (this.$store.state.healthDocUser.isChannelArchive) {
        this.appIdList = [
          {
            appId: this.$store.state.healthDocUser.customerAppId,
            clientName: this.$store.state.healthDocUser.customerAppName,
          },
        ];
        this.appIdList[0].appId = this.$store.state.healthDocUser.customerAppId;
        this.searchParams.appId = this.$store.state.healthDocUser.customerAppId;
        this.getRecordsList();
      } else {
        this.getClientList();
      }
    } else {
      this.searchParams.appId = this.$store.state.healthDocUser.customerAppId;
      this.getRecordsList();
    }

    this.getAbnormalWarning();
    this.getBubbleData();
  },
  watch: {
    "searchParams.appId": {
      handler() {
        this.searchParams.sourcePort = "";
        this.searchParams.sourceEntrance = "";
        this.searchParams.sourceCategory = "";
        // this.getScreenConditionByProfileId();
      },
    },
  },
  methods: {
    // 获取来源端、来源入口、来源类别数据
    async getScreenConditionByProfileId() {
      // let res = null;
      // if (this.$store.state.healthDocUser.isChannelArchive) {
      //   res = await getScreenConditionByProfileId({
      //     userId: this.$store.state.healthDocUser.userId,
      //     appId: this.searchParams.appId,
      //     profileId: this.$store.state.healthDocUser.profileId,
      //   });
      // } else {
      //   res = await getScreenConditionByPhoneNumber({
      //     userId: this.$store.state.healthDocUser.userId,
      //     phoneNumber: this.$store.state.healthDocUser.phone,
      //     appId: this.searchParams.appId,
      //   });
      // }
      // if (res.code == 200) {
      //   if (res.data) {
      //     let { sourcePorts, sourceEntrances, sourceCategories } = res.data;
      //     this.sourcePortList = ["", ...sourcePorts];
      //     this.sourceEntranceList = ["", ...sourceEntrances];
      //     this.sourceCategoryList = ["", ...sourceCategories];
      //   }
      // }
    },
    renderHeaderMethod(h, { column, $index }) {
      return h(
        "div",
        {
          style: "display:flex;justify-content: center;",
        },
        [
          h("span", column.label + "  ", {
            align: "left",
          }),
          h(
            "el-popover",
            {
              props: {
                placement: "top-start", // 一般 icon 处可添加浮层说明，浮层位置等属性
                width: "300",
                trigger: "hover",
              },
            },
            [
              h(
                "p",
                "正常参考值，为体检报告中给出的指标数值正常范围，不同体检机构的指标数值正常范围会有所不同，仅供参考。",
                {
                  class: "text-align: right; margin: 0",
                }
              ),
              h("i", {
                // 生成 i 标签 ，添加icon 设置 样式，slot 必填
                class: "el-icon-info",
                style: "color:#ccc,margin:18px",
                slot: "reference",
              }),
            ]
          ),
        ]
      );
    },
    renderHeaderMethod2(h, { column, $index }) {
      return h(
        "div",
        {
          style: "display:flex;justify-content: center;",
        },
        [
          h("span", column.label + "  ", {
            align: "right",
          }),
          h(
            "el-popover",
            {
              props: {
                placement: "top-start", // 一般 icon 处可添加浮层说明，浮层位置等属性
                width: "180",
                trigger: "hover",
              },
            },
            [
              h("p", "仅供参考，不作为诊断依据", {
                class: "text-align: right; margin: 0",
              }),
              h("i", {
                // 生成 i 标签 ，添加icon 设置 样式，slot 必填
                class: "el-icon-info",
                style: "color:#ccc,margin:18px",
                slot: "reference",
              }),
            ]
          ),
        ]
      );
    },
    async getClientList() {
      const res = await getClientList();
      if (res.code == 200) {
        let list = res.data.map((item) => item.appId);
        this.appIdList[0].appId = [
          this.$store.state.healthDocUser.appId,
          ...list,
        ].join(",");
        this.appIdList = [...this.appIdList, ...res.data];
        this.searchParams.appId = this.appIdList[0].appId;
        this.getRecordsList();
      }
    },
    // 重置
    handerReset() {
      this.current = 1;
      this.searchParams = {
        ...this.searchParams,
        sourcePort: "",
        sourceEntrance: "",
        sourceCategory: "",
        title: "",
      };
      this.searchParams.appId = this.$store.state.healthDocUser.customerAppId;
      this.getRecordsList();
    },
    // 查询
    handerQuery() {
      this.current = 1;
      this.getRecordsList();
    },
    async getAbnormalWarning() {
      const { isChannelArchive, profileId, customerAppId } =
        this.$store.state.healthDocUser;
      if (isChannelArchive) {
        const response = await getAbnormalWarning({
          userId: this.$store.state.healthDocUser.userId,
          profileId,
          appId: customerAppId,
        });
        if (response.code === 1) {
          // 假设 HTTP_STATUS_SUCCESS 是定义好的常量
          const abnormalData = response.data;
          this.abnormalData = abnormalData;
          this.$nextTick(() => {
            this.drawChart4(abnormalData);
          });
        } else {
        }
      } else {
      }
    },
    // 疾病指向预警详情
    drawChart4(data) {
      if (!data.length) {
        return;
      }
      let diseaseGrades = ["0", "5", "10", "15", "20及以上"];
      let colors = ["#7CE7AC", "#5E81F4", "#5E81F4"];
      // 基于准备好的dom，初始化echarts实例,绘制图表
      let zhexianturef = this.$refs.zhexianturef;
      if (!zhexianturef) {
        return;
      }
      var myChart = this.$echarts.init(zhexianturef);
      let xAxisData = [];
      let seriesData1 = [];
      let seriesData2 = [];
      let seriesData3 = [];
      let maxCount = 5;
      data.forEach((item, index) => {
        xAxisData.push(getYMDString(item.dateTime));
        seriesData1.push(item.important);
        seriesData2.push(item.common);
        seriesData3.push(item.total);
        let total = parseInt(item.total);
        if (total > maxCount) {
          maxCount = total;
        }
      });
      let option = {
        color: colors,
        legend: {
          right: "20",
          top: "20",
          data: ["重要指标", "一般指标", "总数"],
        },
        grid: {
          left: "2%",
          right: "2%",
          bottom: "2%",
          containLabel: true,
        },
        dataZoom: {
          type: "inside",
          // start: 0,
          // end: 10,
          // startValue: 0,
          // endValue: xAxisData.length > 9? 9: xAxisData.length,
          startValue: xAxisData.length - 1 > 9 ? xAxisData.length - 1 - 9 : 0,
          endValue: xAxisData.length - 1,
          // minSpan: 10,
          // maxSpan: 50,
          // minValueSpan: 5,
          // maxValueSpan: 10,
          zoomLock: true,
        },
        xAxis: [
          {
            axisLine: {
              lineStyle: {
                color: "#F7F7F7",
              },
            },
            axisTick: {
              show: false,
            },
            // type: 'category',
            data: xAxisData,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              fontSize: 12,
              color: "#3B4859",
            },
          },
        ],
        yAxis: [
          {
            axisLine: {
              lineStyle: {
                color: "#F7F7F7",
              },
            },
            axisTick: {
              show: false,
            },
            //网格样式
            splitLine: {
              show: true,
              lineStyle: {
                color: ["#F7F7F7"],
                width: 1,
                type: "solid",
              },
            },
            type: "value",
            name: "异常指标个数",
            nameTextStyle: {
              color: "#666",
              fontSize: 13,
            },
            // max: maxCount,
            // interval: 1,
            minInterval: 1,
            splitNumber: 5,
            axisLabel: {
              color: "#666",
              fontSize: 16,
              // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
              // formatter: function (value, index) {
              //   return diseaseGrades[index];
              // },
            },
          },
        ],
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            name: "重要指标",
            type: "bar",
            barWidth: 12,
            label: {
              show: true,
              position: "top",
            },
            data: seriesData1,
          },
          {
            name: "一般指标",
            type: "bar",
            barWidth: 12,
            label: {
              show: true,
              position: "top",
            },
            data: seriesData2,
          },
          {
            name: "总数",
            type: "line",
            label: {
              show: true,
              position: "top",
            },
            data: seriesData3,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    random(min, max) {
      return Math.random() < 0.5
        ? -1
        : 1 * (Math.floor(Math.random() * (max - min)) + min);
    },
    getDrawIndex(level) {
      if (level == "其他" || level == "") {
        return 1;
      } else if (level == "轻度预警") {
        return 2;
      } else if (level == "中度预警") {
        return 3;
      } else if (level == "高度预警") {
        return 4;
      }
      return 0;
    },
    getScatterColor(val) {
      // console.log(3, val);
      return this.scatterColorList[this.levalList.indexOf(val)];
    },
    getDrawColor(level) {
      // if (level == '其他') {
      //     return '86,180,22';
      // } else if (level == '轻度') {
      //     return '255,204,34';
      // }  else if (level == '中度') {
      //     return '252,140,65';
      // }  else if (level == '重度') {
      //     return '224,32,32';
      // }
      // return '86,180,22';

      if (level == "其他疾病") {
        return "86,180,22";
      } else if (level == "重疾前症") {
        return "252,140,65";
      } else if (level == "重疾") {
        return "224,32,32";
      }
      return "86,180,22";
    },
    textChangeLine(num, str) {
      // 判断文字的长度
      var strOrArr = "";
      if (str.indexOf("\n") !== -1) {
        // 如果文字描述里有换行符
        var strChange = str.split("\n");
        for (var i = 0; i < strChange.length; i++) {
          var strtr = strChange[i];
          var m = 0,
            k = m;
          var newArray1 = [];
          while (m < strtr.length) {
            m += num;
            newArray1.push([strtr.slice(k, m)]);
            k = m;
          }
          strOrArr += newArray1.join("\n");
          if (i !== strChange.length - 1) {
            // 不在最后一次循环加换行
            strOrArr += "\n";
          }
        }
      } else {
        // 如果文字描述里没有换行符
        var j = 0,
          o = j;
        var newArray2 = [];
        while (j < str.length) {
          j += num;
          newArray2.push([str.slice(o, j)]);
          o = j;
        }
        strOrArr = newArray2.join("\n");
      }
      return strOrArr;
    },

    //散点图数据获取
    async getBubbleData() {
      let data = null;
      if (!this.$store.state.healthDocUser.isChannelArchive) {
        let phone = this.$store.state.healthDocUser.phone;
        data = await getHealthDiseasePointHistoryList({
          userId: this.$store.state.healthDocUser.userId,
          phoneNumber: phone,
        });
      } else {
        data = await getBubbleData({
          userId: this.$store.state.healthDocUser.userId,
        });
      }
      if (data.code == 1) {
        let diseaseDirectionData = data.data;
        this.diseaseDirectionData = diseaseDirectionData;
        // this.$store.state.healthDocUser.diseaseDirectionData = diseaseDirectionData;
        this.sandiantu(diseaseDirectionData);
        this.$nextTick(() => {
          this.getxueya();
          this.getxuetang();
          this.getxuezhi();
          this.getniaosuan();
          this.gettizhong();
          this.getbmi();
        });
      }
    },
    // 散点图好的
    sandiantu(diseaseDirectionData) {
      // console.log(1, diseaseDirectionData);
      let diseaseGrades = [
        "",
        "暂无预警数据",
        "轻度预警",
        "中度预警",
        "高度预警",
        "",
      ];
      let dataList = [];
      diseaseDirectionData.forEach((item, index) => {
        let newItem = {};
        newItem.month = getYMDSimple(item.dateTime);
        let list = [];
        let level1 = [];
        let level2 = [];
        let level3 = [];
        let level4 = [];
        1;
        item.diseasePointList.forEach((item1, index1) => {
          let newItem1 = {
            name: item1.diseasePointName,
            level: item1.diseaseLevel,
            warn: item1.earlyWarningLevel,
            earlyWarningLevel: item1.earlyWarningLevel,
          };
          if (
            item1.earlyWarningLevel == "其他" ||
            item1.earlyWarningLevel == ""
          ) {
            level1.push(newItem1);
          } else if (item1.earlyWarningLevel == "轻度预警") {
            level2.push(newItem1);
          } else if (item1.earlyWarningLevel == "中度预警") {
            level3.push(newItem1);
          } else if (item1.earlyWarningLevel == "高度预警") {
            level4.push(newItem1);
          }
        });
        if (level1.length) {
          list.push({
            level: level1,
          });
        }
        if (level2.length) {
          list.push({
            level: level2,
          });
        }
        if (level3.length) {
          list.push({
            level: level3,
          });
        }
        if (level4.length) {
          list.push({
            level: level4,
          });
        }

        newItem.list = list;
        dataList.push(newItem);
      });

      var months = [""];
      var datas1 = [];
      for (var i = 0; i < dataList.length; i++) {
        let item = dataList[i];
        months.push(item.month);
        for (let j = 0; j < item.list.length; j++) {
          let item1 = item.list[j];
          for (let k = 0; k < item1.level.length; k++) {
            let item2 = item1.level[k];
            item2.name = this.textChangeLine(3, item2.name);
            // let x = 50*(i + 1) + (this.random(1,10));
            let x = 50 * (i + 1) + this.random(1, 2);
            if (item1.level.length == 1) {
            } else if (item1.level.length == 2) {
              if (k < 1) {
                x -= 5;
              } else {
                x += 5;
              }
            } else if (item1.level.length == 3) {
              if (k < 1) {
              } else if (k < 2) {
                x -= 5;
              } else {
                x += 5;
              }
            } else if (item1.level.length >= 4) {
              if (k % 2) {
                x -= 5;
              } else {
                x += 5;
              }
            }

            let y = this.getDrawIndex(item2.warn) * 50 + this.random(1, 5);
            if (item1.level.length == 1) {
            } else if (item1.level.length == 2) {
            } else if (item1.level.length == 3) {
              if (k < 1) {
                y += 15;
              } else {
                y -= 15;
              }
            } else if (item1.level.length >= 4) {
              if (k % 4 < 2) {
                y += 15;
              } else {
                y -= 15;
              }
            }
            // console.log(2, item1);
            datas1.push({
              ...item2,
              symbolSize: 52,
              value: [x, y],
              label: {
                normal: {
                  show: true,
                  formatter: "{b}",
                  // color: `rgb(${this.getDrawColor(item2.level)})`,
                  color: "#ffffff",
                  textStyle: {
                    fontSize: "12",
                  },
                  verticalAlign: "middle",
                },
              },
              itemStyle: {
                color: this.getScatterColor(item1.level[0].warn),
              },
            });
          }
        }
      }
      setTimeout(() => {
        // 散点图
        let sandianturef = this.$refs.sandianturef;
        if (!sandianturef) {
          return;
        }

        var myChart = this.$echarts.init(sandianturef);
        window.addEventListener("resize", () => {
          myChart.resize();
        });
        if (months.length <= 5) {
          let option = {
            grid: {
              left: "4%",
              right: "4%",
              bottom: "6%",
              containLabel: true,
            },

            xAxis: [
              {
                type: "value",
                axisLine: {
                  lineStyle: {
                    color: "#F7F7F7",
                  },
                },
                axisTick: {
                  show: false,
                },
                //网格样式
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ["#F7F7F7"],
                    width: 1,
                    type: "solid",
                  },
                },
                min: 0,
                max: months.length * 50,
                interval: 50,
                // offset: 50,
                axisLabel: {
                  color: "#3B4859",
                  fontSize: 12,
                  // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
                  formatter: function (value, index) {
                    return months[index];
                  },
                },
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "疾病程度",
                nameTextStyle: {
                  color: "#666",
                  fontSize: 13,
                },
                axisLine: {
                  lineStyle: {
                    color: "#F7F7F7",
                  },
                },
                axisTick: {
                  show: false,
                },
                //网格样式
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ["#F7F7F7"],
                    width: 1,
                    type: "solid",
                  },
                },
                min: 0,
                max: 250,
                interval: 50,
                axisLabel: {
                  color: "#666",
                  fontSize: 16,
                  // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
                  formatter: function (value, index) {
                    return diseaseGrades[index];
                  },
                },
              },
            ],
            series: [
              {
                name: "重疾",
                type: "scatter",
                symbol: "circle",
                data: datas1,
              },
            ],
          };
          // 使用刚指定的配置项和数据显示图表。
          myChart.setOption(option);
        } else {
          let option = {
            // color: colors,
            // legend: {
            //   right: "20",
            //   top: "20",
            //   data: ["重疾", "重疾前症", "其他疾病"],
            // },
            dataZoom: {
              type: "inside",
              start: 0,
              end: (5 / months.length) * 100,
              // end: months.length <= 5?100: 5/months.length*100,
              // startValue: 0,
              // endValue: 4,
              // minSpan: 0,
              // maxSpan: 60,
              // minValueSpan: 5,
              // maxValueSpan: 10,
              zoomLock: true,
            },
            grid: {
              left: "4%",
              right: "4%",
              bottom: "6%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "value",
                axisLine: {
                  lineStyle: {
                    color: "#F7F7F7",
                  },
                },
                axisTick: {
                  show: false,
                },
                //网格样式
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ["#F7F7F7"],
                    width: 1,
                    type: "solid",
                  },
                },
                // min: 0,
                // max: months.length * 50,
                // interval: 50,
                // offset: 50,
                axisLabel: {
                  color: "#3B4859",
                  fontSize: 12,
                  // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
                  formatter: function (value, index) {
                    return months[index];
                  },
                },

                // type: "category",
                // data: [
                //   "1月",
                //   "2月",
                //   "3月",
                //   "4月",
                // ],
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "疾病程度",
                nameTextStyle: {
                  color: "#666",
                  fontSize: 13,
                },
                axisLine: {
                  lineStyle: {
                    color: "#F7F7F7",
                  },
                },
                axisTick: {
                  show: false,
                },
                //网格样式
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ["#F7F7F7"],
                    width: 1,
                    type: "solid",
                  },
                },
                min: 0,
                max: 250,
                interval: 50,
                axisLabel: {
                  color: "#666",
                  fontSize: 16,
                  // 使用函数模板，函数参数分别为刻度数值（类目），刻度的索引
                  formatter: function (value, index) {
                    return diseaseGrades[index];
                  },
                },
              },
            ],
            series: [
              {
                name: "重疾",
                type: "scatter",
                symbol: "circle",
                data: datas1,
              },
            ],
          };
          // 使用刚指定的配置项和数据显示图表。
          myChart.setOption(option);
        }
      }, 1000);
    },
    async getxueya() {
      let data = await getAnomalData([
        {
          type: "xueya",
          time: this.xueyaV,
          userId: this.$store.state.healthDocUser.userId,
        },
      ]);

      if (data.code == 1) {
        if (data.data.length > 0) {
          // 收缩压
          let shousuoyaValue = [];
          let shousuoyaDate = [];
          //舒张压
          let shuzhangyaValue = [];
          let shuzhangyaDate = [];
          data.data.forEach((item) => {
            if (item.type == "shousuoya") {
              shousuoyaValue = item.value;
              shousuoyaDate = item.date;
            } else {
              shuzhangyaDate = item.date;
              shuzhangyaValue = item.value;
            }
          });
          this.$nextTick(() => {
            this.drawxueya(
              shousuoyaValue,
              shousuoyaDate,
              shuzhangyaValue,
              shuzhangyaDate
            );
          });
          // this.drawxueya(
          //   shousuoyaValue,
          //   shousuoyaDate,
          //   shuzhangyaValue,
          //   shuzhangyaDate
          // );
        }
      }
    },
    // 血压1
    drawxueya(shousuoyaValue, shousuoyaDate, shuzhangyaValue) {
      let xueya = this.$refs.xueya;
      if (!xueya) {
        return;
      }
      var myChart = this.$echarts.init(xueya);
      let option = {
        color: ["#7CE7AC", "#5E81F4", "#5E81F4"],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["收缩压", "舒张压"],
        },
        grid: {
          top: "10%",
          left: "3%",
          right: "8%",
          bottom: "3%",
          containLabel: true,
        },

        xAxis: {
          type: "category",
          boundaryGap: false,
          data: shousuoyaDate,
          axisLine: {
            lineStyle: {
              color: "#c7c7c7", // x轴颜色
            },
          },
          axisTick: {
            lineStyle: {
              color: "#c7c7c7", // x轴刻度颜色
            },
          },
          axisLabel: {
            color: "#666666",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#c7c7c7", // y轴颜色
            },
          },
          axisTick: {
            lineStyle: {
              color: "#c7c7c7", // y轴刻度颜色
            },
          },
          axisLabel: {
            color: "#666666",
          },
        },
        series: [
          {
            name: "收缩压",
            type: "line",
            // stack: "Total",
            data: shousuoyaValue,
            markLine: {
              symbol: ["none", "none"],
              data: [
                {
                  yAxis: 140,
                  lineStyle: {
                    color: "#7CE7AC", // 设置标记线的颜色
                    type: "solid", // 设置线的类型，这里是实线
                  },
                },
                {
                  yAxis: 90,
                  lineStyle: {
                    color: "#5E81F4", // 设置标记线的颜色
                    type: "solid", // 设置线的类型，这里是实线
                  },
                },
              ],
            },
          },
          {
            name: "舒张压",
            type: "line",
            // stack: "Total",
            data: shuzhangyaValue,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    async getxuetang() {
      let data = await getAnomalData([
        {
          type: "xuetang",
          time: this.xuetangV,
          userId: this.$store.state.healthDocUser.userId,
        },
      ]);
      if (data.code == 1) {
        if (data.data.length > 0) {
          let d = data.data[0];
          this.drawxuetang(d.date, d.value);
        }
      }
    },
    // 血糖2
    drawxuetang(date, value) {
      let xuetang = this.$refs.xuetang;
      if (!xuetang) {
        return;
      }
      var myChart = this.$echarts.init(xuetang);
      let option = {
        color: ["#7CE7AC", "#5E81F4", "#5E81F4"],
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "3%",
          left: "3%",
          right: "8%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
          axisLine: {
            lineStyle: {
              color: "#c7c7c7", // x轴颜色
            },
          },
          axisTick: {
            lineStyle: {
              color: "#c7c7c7", // x轴刻度颜色
            },
          },
          axisLabel: {
            color: "#666",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#c7c7c7", // x轴颜色
            },
          },
          axisTick: {
            lineStyle: {
              color: "#c7c7c7", // x轴刻度颜色
            },
          },
          axisLabel: {
            color: "#666",
          },
        },
        series: [
          {
            name: "空腹血糖",
            type: "line",
            stack: "Total",
            data: value,
            markLine: {
              symbol: ["none", "none"],
              data: [
                {
                  yAxis: 6.0,
                  lineStyle: {
                    color: "#7CE7AC", // 设置标记线的颜色
                    type: "solid", // 设置线的类型，这里是实线
                  },
                },
                {
                  yAxis: 3.9,
                  lineStyle: {
                    color: "#5E81F4", // 设置标记线的颜色
                    type: "solid", // 设置线的类型，这里是实线
                  },
                },
              ],
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
    async getxuezhi() {
      let data = await getAnomalData([
        {
          type: "xuezhi",
          time: this.xuezhiV,
          userId: this.$store.state.healthDocUser.userId,
        },
      ]);
      if (data.code == 1) {
        if (data.data.length > 0) {
          let d = data.data[0];
          this.drawxuezhi(d.date, d.value);
        }
      }
    },
    // 血脂3
    drawxuezhi(date, value) {
      let xuezhi = this.$refs.xuezhi;
      if (!xuezhi) {
        return;
      }
      var myChart = this.$echarts.init(xuezhi);
      let option = {
        color: ["#7CE7AC", "#5E81F4", "#5E81F4"],
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "3%",
          left: "3%",
          right: "8%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
          axisLine: {
            lineStyle: {
              color: "#c7c7c7", // x轴颜色
            },
          },
          axisTick: {
            lineStyle: {
              color: "#c7c7c7", // x轴刻度颜色
            },
          },
          axisLabel: {
            color: "#666",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#c7c7c7", // x轴颜色
            },
          },
          axisTick: {
            lineStyle: {
              color: "#c7c7c7", // x轴刻度颜色
            },
          },
          axisLabel: {
            color: "#666",
          },
        },
        series: [
          {
            name: "血脂(总胆固醇)",
            type: "line",
            stack: "Total",
            data: value,
            markLine: {
              symbol: ["none"],
              data: [
                {
                  yAxis: 5.2,
                  lineStyle: {
                    color: "#7CE7AC", // 设置标记线的颜色
                    type: "solid", // 设置线的类型，这里是实线
                  },
                },
              ],
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    async getniaosuan() {
      let data = await getAnomalData([
        {
          type: "niaosuan",
          time: this.niaosuanV,
          userId: this.$store.state.healthDocUser.userId,
        },
      ]);
      if (data.code == 1) {
        if (data.data.length > 0) {
          let d = data.data[0];
          this.drawniaosuan(d.date, d.value);
        }
      }
    },
    // 尿酸4
    drawniaosuan(date, value) {
      let niaosuan = this.$refs.niaosuan;
      if (!niaosuan) {
        return;
      }
      var myChart = this.$echarts.init(niaosuan);
      let option = {
        color: ["#7CE7AC", "#5E81F4", "#5E81F4"],
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "3%",
          left: "3%",
          right: "8%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
          axisLine: {
            lineStyle: {
              color: "#c7c7c7", // x轴颜色
            },
          },
          axisTick: {
            lineStyle: {
              color: "#c7c7c7", // x轴刻度颜色
            },
          },
          axisLabel: {
            color: "#666",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#c7c7c7", // x轴颜色
            },
          },
          axisTick: {
            lineStyle: {
              color: "#c7c7c7", // x轴刻度颜色
            },
          },
          axisLabel: {
            color: "#666",
          },
        },
        series: [
          {
            name: "尿酸",
            type: "line",
            stack: "Total",
            data: value,
            markLine: {
              symbol: ["none"],
              data: [
                {
                  yAxis: 420,
                  lineStyle: {
                    color: "#7CE7AC", // 设置标记线的颜色
                    type: "solid", // 设置线的类型，这里是实线
                  },
                },
              ],
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    async gettizhong() {
      let data = await getAnomalData([
        {
          type: "tizhong",
          time: this.tizhongV,
          userId: this.$store.state.healthDocUser.userId,
        },
      ]);
      if (data.code == 1) {
        if (data.data.length > 0) {
          let d = data.data[0];
          this.drawtizhong(d.date, d.value);
        }
      }
    },
    // 体重5
    drawtizhong(d, v) {
      let tizhong = this.$refs.tizhong;
      if (!tizhong) {
        return;
      }
      var myChart = this.$echarts.init(tizhong);
      let option = {
        color: ["#7CE7AC", "#5E81F4", "#5E81F4"],
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "3%",
          left: "3%",
          right: "8%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: d,
          axisLine: {
            lineStyle: {
              color: "#c7c7c7", // x轴颜色
            },
          },
          axisTick: {
            lineStyle: {
              color: "#c7c7c7", // x轴刻度颜色
            },
          },
          axisLabel: {
            color: "#666",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#c7c7c7", // x轴颜色
            },
          },
          axisTick: {
            lineStyle: {
              color: "#c7c7c7", // x轴刻度颜色
            },
          },
          axisLabel: {
            color: "#666",
          },
        },
        series: [
          {
            name: "体重",
            type: "line",
            stack: "Total",
            data: v,
            markLine: {
              symbol: ["none"],
              data: [
                {
                  yAxis: 60,
                  lineStyle: {
                    color: "#7CE7AC", // 设置标记线的颜色
                    type: "solid", // 设置线的类型，这里是实线
                  },
                },
              ],
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    async getbmi() {
      let data = await getAnomalData([
        {
          type: "bmi",
          time: this.bmiV,
          userId: this.$store.state.healthDocUser.userId,
        },
      ]);
      if (data.code == 1) {
        if (data.data.length > 0) {
          let d = data.data[0];
          this.drawbmi(d.date, d.value);
        }
      }
    },
    // BMI6
    drawbmi(d, v) {
      let bmi = this.$refs.bmi;
      if (!bmi) {
        return;
      }
      var myChart = this.$echarts.init(bmi);
      let option = {
        color: ["#7CE7AC", "#5E81F4", "#5E81F4"],
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: "3%",
          left: "3%",
          right: "8%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: d,
          axisLine: {
            lineStyle: {
              color: "#c7c7c7", // x轴颜色
            },
          },
          axisTick: {
            lineStyle: {
              color: "#c7c7c7", // x轴刻度颜色
            },
          },
          axisLabel: {
            color: "#666",
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            lineStyle: {
              color: "#c7c7c7", // x轴颜色
            },
          },
          axisTick: {
            lineStyle: {
              color: "#c7c7c7", // x轴刻度颜色
            },
          },
          axisLabel: {
            color: "#666",
          },
        },
        series: [
          {
            name: "BMI",
            type: "line",
            stack: "Total",
            data: v,
            markLine: {
              symbol: ["none", "none"],
              data: [
                {
                  yAxis: 18.5,
                  lineStyle: {
                    color: "#7CE7AC", // 设置标记线的颜色
                    type: "solid", // 设置线的类型，这里是实线
                  },
                },
                {
                  yAxis: 24,
                  lineStyle: {
                    color: "#5E81F4", // 设置标记线的颜色
                    type: "solid", // 设置线的类型，这里是实线
                  },
                },
              ],
            },
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    array2obj(array, key) {
      var resObj = {};
      for (var i = 0; i < array.length; i++) {
        resObj[array[i][key]] = array[i];
      }
      return resObj;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getRecordsList();
    },
    handleCurrentChange(index) {
      if (index == this.current) {
        return;
      } else {
        this.current = index;
      }
      this.getRecordsList();
    },
    async getRecordsList() {
      // let data = null;
      // let { appId, sourcePort, sourceEntrance, sourceCategory, title } =
      // this.searchParams;
      // if (this.$store.state.healthDocUser.isChannelArchive) {
      const data = await getRecordsList({
        userId: this.$store.state.healthDocUser.userId,
        pageNo: this.current,
        pageSize: this.pageSize,
        title: this.searchParams.title,
        // sourcePort,
        // sourceEntrance,
        // sourceCategory,
        // title,
      });
      // } else {
      //   let phone = this.$store.state.healthDocUser.phone;
      // data = await getHealthUserAbnormalIndicatorList({
      //   userId: this.$store.state.healthDocUser.userId,
      //   pageNum: this.current,
      //   pageSize: this.pageSize,
      //   appId,
      //   sourcePort,
      //   sourceEntrance,
      //   sourceCategory,
      //   title,
      // });
      // }

      if (data.code == 1) {
        this.anomalyIndexData = data.data.list;
        data.data.items.forEach((oo) => {
          this.allList.push({
            value: oo,
            label: oo,
          });
        });
        // var dataList = [];
        // for (var i = 0; i < tableData.length; i++) {
        //   let itemData = tableData[i];
        //   // itemData.dateTimeString = getYMDSimple(itemData.dateTime);
        //   dataList.push(itemData);
        // }
        // this.anomalyIndexData = dataList;
        this.totalCount = data.data.total;
      }
    },
    async getHAbnormalIndicator(item) {
      // let data = null;
      // if (this.$store.state.healthDocUser.isChannelArchive) {
      //   data = await getHAbnormalIndicator({
      //     userId: this.$store.state.healthDocUser.userId,
      //     userAbnormalIndicatorId: userAbnormalIndicatorId,
      //   });
      // } else {
      //   let phone = this.$store.state.healthDocUser.phone;
      //   data = await getHealthAbnormalIndicator({
      //     userId: this.$store.state.healthDocUser.userId,
      //     userAbnormalIndicatorId: userAbnormalIndicatorId,
      //   });
      // }

      // if (data.code == 1) {
      let decodeData = item;

      this.gridData = [];
      if (!isEmpty(decodeData.baseItemName)) {
        let data = {
          name: "指标",
          description: decodeData.baseItemName,
        };
        this.gridData.push(data);
      }
      if (!isEmpty(decodeData.meaning)) {
        let data = {
          name: "指标含义说明",
          description: decodeData.meaning,
        };
        this.gridData.push(data);
      }
      if (!isEmpty(decodeData.referenceValue)) {
        let description = decodeData.referenceValue;
        if (decodeData.baseItemUnit) {
          description = description + decodeData.baseItemUnit;
        }
        let data = {
          name: "正常参考值",
          description: description,
        };
        this.gridData.push(data);
      }
      if (!isEmpty(decodeData.baseItemValue)) {
        let description = decodeData.baseItemValue;
        if (decodeData.baseItemUnit) {
          description = description + decodeData.baseItemUnit;
        }
        let data = {
          name: "结果值",
          description: description,
        };
        this.gridData.push(data);
      }
      if (!isEmpty(decodeData.abnormalTips)) {
        let data = {
          name: "异常提示",
          description: decodeData.abnormalTips,
        };
        this.gridData.push(data);
      }
      if (!isEmpty(decodeData.reason)) {
        let data = {
          name: "常见原因",
          description: decodeData.reason,
        };
        this.gridData.push(data);
      }
      if (!isEmpty(decodeData.suggestions)) {
        let data = {
          name: "建议",
          description: decodeData.suggestions,
        };
        this.gridData.push(data);
      }
      // 资料来源
      if (!isEmpty(decodeData.source)) {
        let data = {
          name: "资料来源",
          description: decodeData.source,
        };
        this.gridData.push(data);
      }
      //指向疾病
      if (!isEmpty(decodeData.diseasePointName)) {
        let data = {
          name: "指向疾病",
          description: decodeData.diseasePointName,
        };
        this.gridData.push(data);
      }
      // 预警等级
      if (!isEmpty(decodeData.level)) {
        let data = {
          name: "预警等级",
          description: decodeData.level,
        };
        this.gridData.push(data);
      }

      // if (!isEmpty(decodeData.abnormalConsequence)) {
      //   let data = {
      //     name: "可能影响",
      //     description: decodeData.abnormalConsequence,
      //   };
      //   this.gridData.push(data);
      // }
      this.dialogTableVisible = true;
      // }
    },
    handleDecode(item) {
      this.getHAbnormalIndicator(item);
    },
    handleCheck(index, reportId) {
      this.$router.push({
        name: "体检报告审核页面详情单页",
        query: {
          reportIdKey: reportId,
          handleState: "check",
        },
      });
    },
  },
};
</script>

<style scoped>
.right-btns {
  text-align: right;
}
.main {
  min-width: 1080px;
  /* padding-left: 16px; */
  /* padding-right: 30px; */
  /* padding: 100px 0; */
  overflow: scroll;
  position: relative;
  height: 100%;
  overflow-x: hidden;
}

h1 {
  padding-top: 20px;
  color: #333333;
  font-size: 16px;
}

.riskStatistical {
  overflow: hidden;
  margin-top: 10px;
  background-color: #fff;
}
.tubiaosize {
  width: 100%;
  height: 400px;
}

.table {
  padding-top: 20px;
  /* padding-left: 20px;
      padding-right: 30px; */
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.disease-mark {
  color: rgba(255, 140, 0, 1);
  background-color: rgba(255, 140, 0, 0.1);
  padding: 4px;
}

.effective-icon {
  display: inline-block;
  width: 4px;
  height: 4px;
  background-color: #00be27;
  border-radius: 2px;
  position: relative;
  top: -2px;
}

.effective-icon-highlight {
  background-color: #b8b8b8;
}

.block104 {
  text-align: center;
  margin-top: 23px;
  margin-bottom: 20px;
}

.healthNonData {
  position: relative;
  height: 600px;
}

.healthNonDataImage {
  width: 400px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.healthNonDataText {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  color: #999999;
  text-align: center;
  position: absolute;
  left: 0px;
  bottom: 100px;
}
.resetButton {
  float: right;
  margin-left: 30px;
  margin-right: 30px;
}
.search-box {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding-right: 30px;
}
</style>
<style>
.block104 .el-pager li:last-child {
  display: inline-block !important;
}

.block104 .el-pager li:first-child {
  display: inline-block !important;
}
</style>
